import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { selectHasPushError } from '@ff-os/pdp-shared-redux/slices/snapshotSlice';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { noop } from 'lodash';
import { useOrientation } from '../../context/Orientation';
import { usePreviewSize } from '../../context/PreviewSize';
import { OverviewWindowBody } from '../mobile/partials/OverviewWindowBody';
import { GiftWindowStepProps } from './giftWindowSteps';
import { GiftWindowFooter } from './partials/GiftWindowFooter';

const _OverviewWindow = ({
    onClose, previous, next,
    nextButtonText, hasPushError
}: Props) => {

    const { t } = useTranslation();
    const [quantity, setQuantity] = useState(1);
    usePreviewSize('large');
    useOrientation(useMobile() ? 'screen' : 'portrait');

    return (
        <WindowContext isOpen close={noop} deps={[quantity]}>
            <WindowContext.Header>
                <WindowHeader previous={previous ?? onClose}>
                    {t('windows.overview.heading')}
                </WindowHeader>
            </WindowContext.Header>
            <WindowContext.Body>
                <OverviewWindowBody
                    quantity={quantity} setQuantity={setQuantity}
                    hasPushError={hasPushError} />
            </WindowContext.Body>
            <WindowContext.Footer>
                <GiftWindowFooter
                    quantity={quantity}
                    onClose={onClose}
                    next={next} nextButtonText={nextButtonText}
                    previous={previous} previousButtonText={t('commons.adjust')} />
            </WindowContext.Footer>
        </WindowContext>
    );
};

type Props = GiftWindowStepProps & {
    hasPushError: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    hasPushError: selectHasPushError(state)
});

export const OverviewWindow = connect(
    mapStateToProps
)(_OverviewWindow);